export interface StepValues {
  step1: string | undefined;
  step2: string | undefined;
  step3: string | undefined;
}

export interface SetSetpValuesProps {
  newStep: number;
  value: string;
}

export enum ValueByStep {
  volume = 0,
  providers = 1,
  people = 2,
}
